import { axiosInstance } from '../axios/axiosConfig';

const controller = 'favorites';

export const setFavoriteTrainer = async (id) => {
    try {
        const response = await axiosInstance.post(`/${controller}/favorite/${id}`);
        return response;
    } catch (error) {
        throw error.response?.data || error.message;
    }
}